'use strict';

import {
  apiUrl
} from '../../app.api.config';

export default class SubscribeService {
  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  };
  getList = function (request) {
    return this.$http.post(apiUrl().API_URL + '/admin/subscribe/dataPage', request);
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/model/Subscribe.js